export default __webpack_public_path__ + "static/media/Element 3.207fe78e.svg";